<section class="xl:sticky xl:top-4 xl:self-start flex flex-col gap-y-4 my-3">
  <!-- Pills -->
  <section class="flex justify-between items-center">
    <div class="gap-2 hidden lg:flex">
      <span
        class="px-3 py-1 rounded-full text-white text-xs"
        [ngClass]="
          listingDetails?.type === 'Sold'
            ? 'bg-[#6C7884] text-white'
            : listingDetails?.type === 'LeaseTakeover'
            ? 'bg-[#ff9e00] text-white'
            : listingDetails?.type === 'SalePending'
            ? 'bg-[#fe0] !text-black'
            : 'bg-red-600 text-white'
        "
        >{{ listingDetails?.type ?? '' | capitalizeWithSpaces }}</span
      >
      <span class="bg-black px-3 py-1 rounded-full text-white text-xs">{{
        listingDetails?.dealer ? 'Dealer' : 'Private Seller'
      }}</span>
    </div>
    <h3 class="text-2xl lg:text-3xl font-bold">
      {{ listingDetails?.price?.value | currency }}
    </h3>
  </section>

  <!-- Details -->
  <div class="flex flex-col gap-y-3">
    <h1 class="text-2xl font-bold text-gray-800">
      {{ listingDetails?.vehicle?.year || 'UnKnown' }}
      {{ listingDetails?.vehicle?.model || 'UnKnown' }}
      {{ listingDetails?.vehicle?.trim || 'UnKnown' }}
    </h1>
    <div class="w-full flex flex-col gap-3">
      <span
        class="bg-[#EAF6FF] py-1 rounded-full flex items-center gap-1.5 px-3"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 16 16"
        >
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M8 1a5 5 0 0 0-5 5c0 1.14.56 2.488 1.377 3.934c.827 1.463 1.967 3.107 3.216 4.857l.407.57l.407-.57c1.25-1.75 2.389-3.394 3.216-4.857C12.44 8.488 13 7.14 13 6a5 5 0 0 0-5-5m0 2.5a2.5 2.5 0 1 0 0 5a2.5 2.5 0 0 0 0-5"
            clip-rule="evenodd"
          /></svg
        >{{ listingDetails?.location?.city || 'UnKnown' }},
        {{ listingDetails?.location?.state || 'UnKnown' }}</span
      >
      <div class="grid grid-cols-2 gap-1 w-full">
        <span
          class="bg-[#EAF6FF] flex items-center gap-1.5 py-1 px-3 rounded-full"
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="20"
            viewBox="0 0 576 512"
          >
            <path
              fill="#2f2f2f"
              d="m573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33M260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68"
            /></svg
          >{{ (listingDetails?.vehicle?.mileage | number) || 0 }} miles</span
        >
        <span
          class="bg-[#EAF6FF] flex py-1 items-center gap-1.5 px-3 rounded-full"
          >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M21.907 9.641a1.1 1.1 0 0 0-.088-1.05c-.27-.519-2.14-.647-2.056-.033c.034.248.1.416-.206.446a2.4 2.4 0 0 1-.137-.317l-.53-1.627a2.65 2.65 0 0 0-1.282-1.5l-.373-.2A3.9 3.9 0 0 0 15.4 4.9H8.605a3.9 3.9 0 0 0-1.837.457l-.372.2a2.65 2.65 0 0 0-1.282 1.5L4.58 8.682A2.4 2.4 0 0 1 4.444 9c-.308-.03-.241-.2-.207-.446c.084-.614-1.786-.486-2.056.033a1.1 1.1 0 0 0-.088 1.05a2.16 2.16 0 0 0 1.721.287l-1.079 1.317a2.1 2.1 0 0 0-.578 1.459l.029 5.364A1.083 1.083 0 0 0 3.3 19.1h1.644a.5.5 0 0 0 .516-.475v-.021L5.432 17.4h13.142l-.029 1.21a.5.5 0 0 0 .5.5h1.664a1.083 1.083 0 0 0 1.116-1.04l.03-5.364a2.1 2.1 0 0 0-.578-1.459l-1.091-1.324a2.16 2.16 0 0 0 1.721-.282M5.388 8.9a3.18 3.18 0 0 1 3.279-3.07h6.666a3.183 3.183 0 0 1 3.281 3.076v.45a.125.125 0 0 1-.125.124H5.512a.124.124 0 0 1-.124-.124Zm1.393 4.029a.25.25 0 0 1-.205.115h-3.06c-.136 0-.418-.062-.418-.475l.207-1.069c.071-.372.806-.351 1.133-.156L6.7 12.591a.25.25 0 0 1 .081.342zM20.7 11.5l.207 1.073c0 .413-.282.475-.418.475h-3.06a.247.247 0 0 1-.124-.457l2.266-1.247c.318-.195 1.053-.218 1.129.156"
            /></svg
          >{{
            listingDetails?.vehicle?.condition || 'Unknown'
              | capitalizeWithSpaces
          }}</span
        >
      </div>

      <div
        class="bg-[#EAF6FF] flex py-0.5 items-center gap-1.5 px-3 rounded-full basis-1/3"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
        >
          <path
            fill="#2f2f2f"
            d="M18 2H7c-1.103 0-2 .897-2 2v3c0 1.103.897 2 2 2h11c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2"
          />
          <path
            fill="currentColor"
            d="M13 15v-2c0-1.103-.897-2-2-2H4V5c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h7v2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1"
          /></svg
        >{{ listingDetails?.vehicle?.specification?.colour || 'Unknown' }}
      </div>
    </div>

    <button
      (click)="toggleTaxDialog()"
      (keyup)="toggleTaxDialog()"
      *ngIf="listingDetails?.vehicle?.tax?.relief === true"
      class="font-semibold w-full px-4 py-1 rounded-xl border flex items-center justify-center gap-1.5 mx-auto cursor-pointer"
    >
      {{ (listingDetails?.price?.value ?? 0) - 4000 | currency }}
      <span class="flex items-center justify-center gap-2"
        >after tax relief
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
        >
          <g
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 16v-4m0-4h.01" />
          </g></svg
      ></span>
    </button>

    <button
    (click)="toggleTaxDialog()"
      (keyup)="toggleTaxDialog()"
      *ngIf="listingDetails?.vehicle?.tax?.reliefApplied === true"
      class="ont-semibold w-full px-4 py-1 rounded-xl border flex items-center justify-center gap-1.5 mx-auto cursor-pointer"
    >
      Used EV Tax Credit Eligibility
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
      >
        <g
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 16v-4m0-4h.01" />
        </g>
      </svg>
    </button>
  </div>

  <!-- Contact Seller -->
  <div
    *ngIf="includeInformationRequestCard"
    class="w-full border rounded-2xl flex flex-col justify-center items-center gap-3 py-1.5 xl:py-2.5 px-4"
  >
    <h4 class="font-semibold text-lg xl:text-xl">Request Information</h4>
    <button
      *ngIf="(auth.isAuthenticated$ | async) === true"
      [disabled]="listingDetails?.type === 'Sold'"
      (click)="toggleContactDialog($event)"
      class="bg-OUT-Blue hover:bg-blue-800 duration-400 transition-colors text-white py-1.5 rounded-full font-medium w-full disabled:opacity-50 cursor-pointer"
    >
      Contact Seller
    </button>
    <button
      *ngIf="(auth.isAuthenticated$ | async) === false"
      (click)="login()"
      class="bg-OUT-Blue hover:bg-blue-800 duration-400 transition-colors text-white py-1.5 rounded-full font-medium w-full disabled:opacity-50 cursor-pointer"
    >
      Login to Contact Seller
    </button>
    <a
      class="text-OUT-Blue font-medium text-sm md:text-base"
      routerLink="/fraud-awareness"
      >Fraud Awareness</a
    >
  </div>
</section>

<!-- Contact Seller Form (Modal) -->
<section
  *ngIf="isContactModalOpen"
  class="fixed top-0 left-0 flex justify-center items-center w-full h-full z-50 overflow-hidden bg-black z-[1000]"
>
  <div
    class="bg-white w-full h-fit lg:w-[610px] shadow-md rounded-2xl mx-2 md:mx-3.5 lg:mx-5"
  >
    <div class="w-full flex justify-between border-b py-2 lg:py-4 px-2 lg:px-7">
      <h2 class="text-xl lg:text-2xl font-bold">Request information</h2>
      <button
        (click)="toggleDialog()"
        class="flex justify-center items-center rounded-lg size-[30px] hover:bg-slate-300 cursor-pointer"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            fill="#3a3a3a"
            d="m12 13.4l-4.9 4.9q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7l4.9-4.9l-4.9-4.9q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.9 4.9l4.9-4.9q.275-.275.7-.275t.7.275t.275.7t-.275.7L13.4 12l4.9 4.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275z"
          />
        </svg>
      </button>
    </div>

    <div
      *ngIf="formErrors.length > 0"
      class="bg-red-100 px-3 py-2 xl:py-3.5 mx-3 lg:mx-7 rounded mt-3"
    >
      <p class="font-medium">Please correct the following errors:</p>
      <ul class="list-disc list-inside mt-1.5">
        <li class="text-sm" *ngFor="let error of formErrors">{{ error }}</li>
      </ul>
    </div>

    <form
      novalidate
      [formGroup]="requestInfoForm"
      (ngSubmit)="onSubmit()"
      class="flex flex-col gap-y-3 py-3 xl:py-5 px-3 lg:px-7"
    >
      <p class="leading-[1.5]">
        Hello, my name is
        <span class="inline-flex mb-3 mx-2">
          <div class="flex flex-col">
            <input
              id="firstName"
              formControlName="FirstName"
              placeholder="First name"
              type="text"
              class="border rounded-lg px-1.5 py-2 focus:ring-0 focus:outline-OUT-Blue h-fit"
              [ngClass]="{
                'outline outline-red-600 focus:outline-red-600':
                  requestInfoForm.get('FirstName')?.invalid &&
                  requestInfoForm.get('FirstName')?.touched,
              }"
            />
            <!-- <span
              *ngIf="
                requestInfoForm.get('FirstName')?.invalid &&
                (requestInfoForm.get('FirstName')?.dirty ||
                  requestInfoForm.get('FirstName')?.touched)
              "
              class="text-red-500"
            >
              <small class="text-[9px]"> Must provide a first name. </small>
            </span> -->
          </div></span
        >
        <span class="inline-flex mx-2">
          <div class="flex flex-col mb-3">
            <input
              id="lastName"
              formControlName="LastName"
              placeholder="Last name"
              type="text"
              class="border rounded-lg px-1.5 py-2 focus:ring-0 focus:outline-OUT-Blue h-fit"
              [ngClass]="{
              'outline outline-red-500 focus:outline-red-600':
                requestInfoForm.get('LastName')?.invalid &&
                requestInfoForm.get('LastName')?.touched,
            }"
            />
            <!-- <span
              *ngIf="
                requestInfoForm.get('LastName')?.invalid &&
                (requestInfoForm.get('LastName')?.dirty ||
                  requestInfoForm.get('LastName')?.touched)
              "
              class="text-red-500"
            >
              <small class="text-[9px]">
                Please enter a valid email address.
              </small>
            </span> -->
          </div>
        </span>
        and
        <span
          ><select
            name="inquiry-Type"
            class="border mb-3 md:mx-2 rounded-lg px-1.5 py-2.5 focus:outline-none focus:ring-0 focus:border-black"
            formControlName="InquiryType"
            id="inquiry-type"
            [ngClass]="{
              'border-OnlyUsedTeslaRed focus:border-red-600':
                requestInfoForm.get('InquiryType')?.invalid &&
                requestInfoForm.get('InquiryType')?.touched,
            }"
          >
            <option value="" disabled selected>Select an inquiry type</option>
            <option value="Interested">I'm interested in this</option>
            <option value="price">I'd like to know the price</option>
            <option value="test-drive">I'd like to test drive this</option>
          </select></span
        >
        <span class="font-bold">
          {{ listingDetails?.vehicle?.year }}
          {{ listingDetails?.vehicle?.make }}
          {{ listingDetails?.vehicle?.model }}
          {{ listingDetails?.vehicle?.trim }}.
        </span>
        I'm in the
        <span class="inline-flex">
          <div class="flex flex-col my-3 mx-2">
            <input
              id="zipcode"
              formControlName="ZipCode"
              placeholder="Zip Code"
              type="text"
              class="border rounded-lg px-1.5 py-2 focus:ring-0 focus:outline-black"
              [ngClass]="{
                'outline outline-red-500 focus:outline-red-600':
                  requestInfoForm.get('ZipCode')?.invalid &&
                  requestInfoForm.get('ZipCode')?.touched,
              }"
            />
            <!-- <span
              *ngIf="
                requestInfoForm.get('ZipCode')?.invalid &&
                (requestInfoForm.get('ZipCode')?.dirty ||
                  requestInfoForm.get('ZipCode')?.touched)
              "
              class="text-red-500"
            >
              <small class="text-[9px]">
                Please enter a valid email address.
              </small>
            </span> -->
          </div>
        </span>
        area. You can reach me by email
        <span class="mb-3 mr-2 inline-flex">
          <div class="flex flex-col">
            <input
              id="emailAddress"
              formControlName="EmailAddress"
              placeholder="Email Address"
              type="text"
              class="border rounded-lg px-1.5 py-2 focus:ring-0 focus:outline-OUT-Blue 2xl:w-[350px]"
              [ngClass]="{
                'outline outline-red-600 focus:outline-red-600':
                  requestInfoForm.get('EmailAddress')?.invalid &&
                  (requestInfoForm.get('EmailAddress')?.dirty ||
                    requestInfoForm.get('EmailAddress')?.touched)
              }"
            />
            <!-- <span
              *ngIf="
                requestInfoForm.get('EmailAddress')?.invalid &&
                (requestInfoForm.get('EmailAddress')?.dirty ||
                  requestInfoForm.get('EmailAddress')?.touched)
              "
              class="text-red-500"
            >
              <small class="text-[9px]">
                Please enter a valid email address.
              </small>
            </span> -->
          </div>
        </span>
        or by phone at
        <span>
          <input
            type="tel"
            id="phone"
            formControlName="Phone"
            class="mt-1 mx-1.5 rounded-md px-1.5 py-2 border focus:ring-blue-500 focus:border-blue-500"
            placeholder="123-456-7890"
          />
          <div
            *ngIf="
              requestInfoForm.get('Phone')?.invalid &&
              (requestInfoForm.get('Phone')?.dirty ||
                requestInfoForm.get('Phone')?.touched)
            "
            class="text-red-500"
          >
            <small *ngIf="requestInfoForm.get('Phone')?.hasError('pattern')">
              Please enter a valid phone number in the format 123-456-7890.
            </small>
          </div></span
        >. Thank you!
      </p>
      <div>
        <button
          (click)="showComment()"
          type="button"
          class="font-semibold mb-2 flex items-center gap-1 text-OUT-Blue cursor-pointer hover:text-blue-700 transition-colors duration-200"
        >
          @if(isCommentOpen) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M18 12.998H6a1 1 0 0 1 0-2h12a1 1 0 0 1 0 2"
            />
          </svg>
          } @else {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M18 12.998h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5v-5a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2"
            />
          </svg>
          } Add Comment
        </button>
        <textarea
          *ngIf="isCommentOpen"
          formControlName="Comments"
          name="comments"
          class="w-full border border-gray-300 rounded-lg p-2 xl:p-2.5 focus:outline-none focus:ring-0 focus:border-black"
          id=""
        ></textarea>
      </div>
      <!-- <button
        [disabled]="requestInfoForm.invalid && isLoading"
        type="submit"
        class="bg-OUT-Blue hover:bg-blue-900 duration-400 transition-colors text-white font-semibold text-[17px] w-full py-2 lg:py-3 rounded-full cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Check Availability
      </button> -->
      <out-button
        [disabled]="isLoading"
        label="Check Availability"
        loadingLabel="Sending"
        type="submit"
        [isLoading]="isLoading"
        buttonClass="!bg-OUT-Blue !hover:bg-blue-600 transition-colors duration-300 text-white py-2.5 mt-5 xl:mt-4 rounded-lg w-full disabled:bg-OUT-Blue/80 disabled:cursor-default cursor-pointer"
      >
      </out-button>
    </form>
  </div>
</section>

<!-- Tax Relief Dialog (Modal) -->
<section
  *ngIf="isTaxModalOpen"
  class="fixed top-0 left-0 flex justify-center items-center w-full h-full z-50 overflow-hidden bg-black/90 z-[100]"
>
  <div
    class="bg-white w-full 2xl:max-w-[50%] rounded-lg p-3 xl:p-10 flex flex-col gap-1.5 xl:gap-3 mx-2 md:mx-3.5 lg:mx-5"
  >
    <div class="w-full flex justify-end">
      <button
        (click)="toggleTaxDialog()"
        class="text-2xl font-semibold cursor-pointer bg-black/10 hover:bg-black/30 transition-colors rounded p-1 flex items-center justify-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 512 512"
        >
          <path
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="32"
            d="M368 368L144 144m224 0L144 368"
          />
        </svg>
      </button>
    </div>
    <h2 class="text-2xl xl:text-3xl font-bold">
      Used EV Tax Credit Eligibility
    </h2>
    <p>
      For all qualifying used electric vehicle deliveries, eligible customers
      may receive a tax credit of up to $4,000, or up to 30% of the purchase
      price, whichever value is less.
    </p>

    <p>
      Eligible customers must meet all federal requirements, including but not
      limited to the following:
    </p>
    <h4 class="text-xl xl:text-2xl font-semibold">Federal Requirements</h4>
    <ul class="list-disc list-inside">
      <ol class="list-disc list-inside">
        <li>
          <strong>AGI Limitations:</strong>
          <ul class="list-[circle] pl-5 list-inside">
            <li>$150,000 for married couples filing jointly</li>
            <li>$112,500 for heads of households</li>
            <li>$75,000 for all other filers</li>
          </ul>
        </li>
      </ol>
      <li class="my-3">
        <strong>Price Caps:</strong> The total cost is exclusive of taxes at
        time of delivery.
        <ul class="list-[circle] pl-5 list-inside">
          <li>
            All vehicle types: $25,000 or less, including transportation fee (if
            applicable)
          </li>
        </ul>
      </li>
      <li>
        <strong>Vehicle Age:</strong> For calendar year 2024, used vehicles must
        be 2022 model year or older.
      </li>
    </ul>

    <p>
      For the full list of the current requirements, review the IRS website.
    </p>

    <p>
      All personal and vehicle eligibility requirements set by the federal
      government are subject to change.
    </p>
  </div>
</section>


<out-alert></out-alert>